__turbopack_context__.v({
  "actions": "hero-module__vbaAPq__actions",
  "bottom": "hero-module__vbaAPq__bottom",
  "buttonLoading": "hero-module__vbaAPq__buttonLoading",
  "buttonPercent": "hero-module__vbaAPq__buttonPercent",
  "canvas": "hero-module__vbaAPq__canvas",
  "close": "hero-module__vbaAPq__close",
  "controls": "hero-module__vbaAPq__controls",
  "controlsIn": "hero-module__vbaAPq__controlsIn",
  "demoBrand": "hero-module__vbaAPq__demoBrand",
  "divider": "hero-module__vbaAPq__divider",
  "editorial": "hero-module__vbaAPq__editorial",
  "eyebrow": "hero-module__vbaAPq__eyebrow",
  "grain": "hero-module__vbaAPq__grain",
  "hero": "hero-module__vbaAPq__hero",
  "intro": "hero-module__vbaAPq__intro",
  "joystick": "hero-module__vbaAPq__joystick",
  "joystickThumb": "hero-module__vbaAPq__joystickThumb",
  "keys": "hero-module__vbaAPq__keys",
  "liveDot": "hero-module__vbaAPq__liveDot",
  "loadingLine": "hero-module__vbaAPq__loadingLine",
  "loadingSweep": "hero-module__vbaAPq__loadingSweep",
  "mobileHelp": "hero-module__vbaAPq__mobileHelp",
  "poster": "hero-module__vbaAPq__poster",
  "primary": "hero-module__vbaAPq__primary",
  "progress": "hero-module__vbaAPq__progress",
  "projectLink": "hero-module__vbaAPq__projectLink",
  "reset": "hero-module__vbaAPq__reset",
  "scene": "hero-module__vbaAPq__scene",
  "sceneCaption": "hero-module__vbaAPq__sceneCaption",
  "scrollLink": "hero-module__vbaAPq__scrollLink",
  "shade": "hero-module__vbaAPq__shade",
  "walkHelp": "hero-module__vbaAPq__walkHelp",
});
